export default __webpack_public_path__ + "static/media/Logo-3D-White-Text-0100.cae64dcb.png";